import { Flex, MenuItem as CHakraMenuItem } from '@chakra-ui/react';
import styled from '@emotion/styled';

import { Check } from 'assets/assetsV1/iconComponents';

const ItemContainer = styled.div`
  padding: 2px 8px;
  position: relative;
  background: ${(props) => (props.withBackground ? '#fafafa' : 'inherit')};
`;

const StyledMenuItem = styled(CHakraMenuItem)`
  padding: 8px;
  padding-right: 32px;

  border-radius: 4px;

  &:hover {
    background: #e6f1fd;
  }
  background: ${({ $isSelected }) => $isSelected && '#e6f1fd'};
  p {
    color: ${({ $isSelected }) => ($isSelected ? '#104F95' : '#333333')};
  }
`;

export const MenuItem = ({ children, key, isSelected, ...props }) => (
  <ItemContainer key={key}>
    <StyledMenuItem $isSelected={isSelected} {...props}>
      <Flex justifyContent="space-between" alignItems="center" width="100%">
        {children}
        {isSelected && <Check ml="auto" color="button.blue.focus" style={{ position: 'absolute', right: '16px' }} />}
      </Flex>
    </StyledMenuItem>
  </ItemContainer>
);
